import { useContext } from "react";
import { dataContext } from "../../../context/context";
import './cases.css';


function CasesCardDesktop({index}) {

    const { data, isLocal  } = useContext(dataContext);

        let urlPrefix = "/images/";
        if (isLocal) urlPrefix = "https://sushi-tunec.com" + urlPrefix;


    const section = data.sectionsdata.find(s => s.nick === 'cases');
        const paragraph = section ? section.paragraphsdata.find(p => p.nick === 'cases1') : [];

        const gal = paragraph.galerydata[index];
        const text = gal.text;

        return (

            <div className="galery-main__carddesktopinner">
            <div className="galery-main__carddesktopimage" style={{ backgroundImage: `url(${urlPrefix + gal.image})` }}></div>

                <span className="galery-main__city">{text[0]}</span>
                <span className="galery-main__profit">{text[3]}</span>

            </div>

        )

    }

export default CasesCardDesktop;